<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/oKTsJq/tc-custom/9781631595745.jpg?1728259590161" alt="This image is the cover for the book 500 Ketogenic Recipes"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">500 Ketogenic Recipes
      </h1>
      <p class="bookDescription body article font2">
        <b>A comprehensive keto diet cookbook and ultimate starter guide to getting healthy, building muscle, and managing blood sugar.</b><br/><br/>The ketogenic diet emphasizes high ratios of healthy fats, moderate protein, and low carbohydrate intake. While the ketogenic diet isn’t new, there is newly emerging research that the ketogenic lifestyle may help reverse illness, promote longevity, and be the best diet for losing weight. Millions of people are transitioning to a ketogenic diet to look and feel their best. However, doing the ketogenic lifestyle the right way isn’t always easy. How do you keep your macronutrients properly balanced? Which foods are keto-friendly and which aren’t?<br/><br/><i>500 Ketogenic Recipes</i> is here with the answers. Low-carb queen and best-selling author Dana Carpender shows how to live the ketogenic lifestyle deliciously with 500 easy-to-prepare recipes for everything from snacks and appetizers, to main dishes, to drinks and dessert.<br/><br/><i>500 Ketogenic Recipes</i> makes staying in the ketogenic zone simple with hundreds of recipes, pantry and shopping lists, and ketogenic dos and don’ts.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Dana Carpender
      </h2>
      
      <p class="authorDescription body article">Dana Carpender (Bloomington, Indiana) is a pioneer of the low-carb movement and best-selling author of over 14 cookbooks, including The New 500 Low-Carb Recipes,1001 Low-Carb Recipes, 500 Paleo Recipes, 15-Minute Low-Carb Recipes, The Low-Carb Diabetes Solution Cookbook, 200 Low-Carb, High-Fat Recipes, The Low-Carb Diabetes Solution, The Insulin Resistance Solution, 500 Ketogenic Recipes, and many more. To date, her books have sold over a million copies worldwide. She writes about low-carb cooking and nutrition on her Facebook page, Dana Carpender's Hold the Toast Press.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Fair Winds Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?28384b80